export const MAINCOLOR = '#020323'
export const ORANGE = '#FD5901'
export const BACKGROUNDIMAGE = 'vippng.com-bird-flying-png-173203.png'